import { getInfoByMonth } from '@pages/WorkSchedule/utils/getInfoByMonth';

export const getDatesForFewMonths = (
  months: string[],
  offsetDate?: string
): string[] => {
  const result: string[] = [];
  const handledOffsetDate = offsetDate || months[0];
  const datesWithoutOffset: string[] = [];

  (months || []).forEach((month: string) => {
    return datesWithoutOffset.push(...getInfoByMonth(month).daysRange);
  });
  const handledOffsetDateIndex = datesWithoutOffset.indexOf(handledOffsetDate);

  (months || []).forEach((month: string) => {
    return result.push(...getInfoByMonth(month).daysRange);
  });

  return result.slice(handledOffsetDateIndex);
};
